// extracted by mini-css-extract-plugin
export default {"chatRoom":"chatRoom_chatRoom__WbaEw"};